import { styled } from "@mui/material/styles";
import { BSPBody2 } from "../../../../BSPBody2";

export const DeleteWarning = styled(BSPBody2)`
  display: block;
  color: ${({ theme }) => theme.kinetic.v2.palette.rgb.negative};
  margin-top: 20px;
`;
